module.exports = __webpack_public_path__ + "assets/icon-filter-component.ce60fe1e.svg";